import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer 
      className="border-t border-white/5 mt-auto"
      style={{
        background: 'rgba(5, 5, 16, 0.6)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)'
      }}
    >
      <div className="container mx-auto px-4 py-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8 mb-6 md:mb-8">
          {/* Brand Section - Full width on mobile */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-3 mb-3">
              <div className="relative">
                <div 
                  className="absolute inset-0 rounded-lg blur-md opacity-40"
                  style={{
                    background: 'linear-gradient(135deg, rgba(6, 182, 242, 0.4), rgba(0, 31, 89, 0.6))'
                  }}
                />
                <div className="relative w-9 h-9 md:w-10 md:h-10 rounded-lg bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center border border-white/10">
                  <img src="/images/wshido.png" alt="Shido Bridge" className="w-5 h-5 md:w-6 md:h-6" />
                </div>
              </div>
              <div>
                <h3 className="text-base md:text-lg font-bold text-white">Shido Bridge</h3>
                <p className="text-xs text-gray-500">Native SHIDO Bridge</p>
              </div>
            </div>
            <p className="text-xs md:text-sm text-gray-400 leading-relaxed">
              Bridge native SHIDO between Shido Network and Ethereum.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h4 className="text-xs md:text-sm font-semibold text-white mb-3">Quick Links</h4>
            <div className="space-y-2">
              {[
                { label: 'Shidoscan', url: 'https://shidoscan.net' },
                { label: 'Shido DEX', url: 'https://app.shido.io' },
                { label: 'BubbleSwap 🫧', url: 'https://app.bubbleswap.io' },
                { label: 'Terms', url: 'https://shido.io/terms' },
              ].map((link) => (
                <a 
                  key={link.label}
                  href={link.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block text-xs md:text-sm text-gray-400 hover:text-primary-400 transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Community & Social */}
          <div className="col-span-1">
            <h4 className="text-xs md:text-sm font-semibold text-white mb-3">Community</h4>
            <div className="flex gap-2">
              <a 
                href="https://github.com/ShidoGlobal" 
                target="_blank" 
                rel="noopener noreferrer"
                className="group p-2 md:p-2.5 rounded-lg md:rounded-xl bg-white/5 hover:bg-white/10 border border-white/5 hover:border-primary-500/30 transition-all"
                title="GitHub"
              >
                <svg className="h-4 w-4 md:h-5 md:w-5 text-gray-400 group-hover:text-primary-400 transition-colors" fill="currentColor" viewBox="0 0 24 24">
                  <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
                </svg>
              </a>
              <a 
                href="https://x.com/ShidoGlobal" 
                target="_blank" 
                rel="noopener noreferrer"
                className="group p-2 md:p-2.5 rounded-lg md:rounded-xl bg-white/5 hover:bg-white/10 border border-white/5 hover:border-primary-500/30 transition-all"
                title="X (formerly Twitter)"
              >
                <svg className="h-4 w-4 md:h-5 md:w-5 text-gray-400 group-hover:text-primary-400 transition-colors" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
            </div>
            <div className="mt-3 md:mt-4 p-2 md:p-3 rounded-lg md:rounded-xl bg-white/5 border border-white/5">
              <p className="text-[10px] md:text-xs text-gray-500">Built on</p>
              <p className="text-xs md:text-sm text-gray-300 font-medium">XPort Bridge v2</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 border-t border-white/5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex flex-col gap-1 text-center md:text-left">
              <p className="text-sm text-gray-400">
                © {new Date().getFullYear()} Shido Bridge. All rights reserved.
              </p>
              <p className="text-xs text-gray-600 font-medium">
                Powered by MavNode Labs 🧪
              </p>
            </div>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/5">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
                <span className="text-xs text-gray-400">All systems operational</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
